import i18n from '@/main';

window.imgError = (image) => {
    if (image.src.indexOf(require("./noimage2.jpg")) >= 0) return;

    image.src = require("./noimage2.jpg");
    return true;
}

//使用 Prompt.vue 作为 ui , 构建一个 基于 Promise 的异步通用对话框
import Prompt from '@/components/Prompt'
import Vue from 'vue'
import api from "@/api/Api"
import '@/plugins/iview.js'

const prompt = (function () {
    const Instance = new Vue({
        render(h) {
            return h(Prompt);
        }
    });
    const component = Instance.$mount();
    document.body.appendChild(component.$el);
    return Instance.$children[0];
})();

///
///
///
let localizeMapper = null;
let localizeRegexp = {};
let message = new Vue().$Message;
let helper = {

    //使用 Prompt.vue 作为 ui , 构建一个 基于 Promise 的异步通用对话框
    prompt(title, options) {

        prompt.show(title, options);

        return new Promise((resolve, reject) => {
            prompt.$once("hide", (value) => {
                if (value === undefined || value === "")
                    reject();
                else
                    resolve(value);
            });
        })
    },
    now() {
        return new Date().getTime();
    },
    localize(str) {
        if (!str || !str.replace) return str;

        let mapper = localizeMapper || {
            "Const.Result.Success": i18n.t("Const.Result.Success"),
            "Const.Result.InvalidParam": i18n.t("Const.Result.InvalidParam"),
            "Const.Result.NoData": i18n.t("Const.Result.NoData"),
            "Const.Result.Offline": i18n.t("Const.Result.Offline"),

            "Const.Material.Type.Video": i18n.t("Const.Material.Type.Video"),
            "Const.Material.Type.Audio": i18n.t("Const.Material.Type.Audio"),
            "Const.Material.Type.Image": i18n.t("Const.Material.Type.Image"),

            "Const.Material.Status.Init": i18n.t("Const.Material.Status.Init"),
            "Const.Material.Status.Init2": i18n.t("Const.Material.Status.Init2"),
            "Const.Material.Status.Done": i18n.t("Const.Material.Status.Done"),
            "Const.Material.Status.Uploading": i18n.t("Const.Material.Status.Uploading"),
            "Const.Material.Status.Defeated": i18n.t("Const.Material.Status.Defeated"),
            "Const.Material.Status.Progress": i18n.t("Const.Material.Status.Progress"),
            "Const.Material.Status.ProgDefeated": i18n.t("Const.Material.Status.ProgDefeated"),
            "Const.Material.Status.OssIdle": i18n.t("Const.Material.Status.OssIdle"),
            "Const.Material.Status.OssUploading": i18n.t("Const.Material.Status.OssUploading"),
            "Const.Material.Status.OssDefeated": i18n.t("Const.Material.Status.OssDefeated"),
            "Const.Material.Status.GetInfo": i18n.t("Const.Material.Status.GetInfo"),
            "Const.Material.Status.GetAudioInfo": i18n.t("Const.Material.Status.GetAudioInfo"),

            "Const.Material.publishStatus.Init": i18n.t("Const.Material.PublishStatus.Init"),
            "Const.Material.publishStatus.Defeated": i18n.t("Const.Material.PublishStatus.Defeated"),
            "Const.Material.publishStatus.Issue": i18n.t("Const.Material.PublishStatus.Issue"),
            "Const.Material.publishStatus.Uploading3": i18n.t("Const.Material.PublishStatus.Uploading3"),
            "Const.Material.publishStatus.Uploading4": i18n.t("Const.Material.PublishStatus.Uploading4"),
            "Const.Material.publishStatus.Publishing": i18n.t("Const.Material.PublishStatus.Publishing"),

            "Const.Watermark.Type.Image": i18n.t("Const.Watermark.Type.Image"),
            "Const.Watermark.Type.Text": i18n.t("Const.Watermark.Type.Text"),

            "Const.liveRoom.publishStatus.Issue": i18n.t("Const.liveRoom.publishStatus.Issue"),
            "Const.liveRoom.publishStatus.Close": i18n.t("Const.liveRoom.publishStatus.Close"),
            
            "Const.liveRoom.Comment.Issue": i18n.t("Const.liveRoom.Comment.Issue"),
            "Const.liveRoom.Comment.Shield": i18n.t("Const.liveRoom.Comment.Shield"),

            "Const.liveRoom.VodFlag.Live": i18n.t("Const.liveRoom.VodFlag.Live"),
            "Const.liveRoom.VodFlag.PlaybackOpen": i18n.t("Const.liveRoom.VodFlag.PlaybackOpen"),
            "Const.liveRoom.VodFlag.PlaybackClose": i18n.t("Const.liveRoom.VodFlag.PlaybackClose"),
            "Const.liveRoom.VodFlag.Trailer": i18n.t("Const.liveRoom.VodFlag.Trailer"),

            "Const.liveRoom.RecordType.UploadRecord": i18n.t("Const.liveRoom.RecordType.UploadRecord"),
            "Const.liveRoom.RecordType.LiveRecord": i18n.t("Const.liveRoom.RecordType.LiveRecord"),
            "Const.liveRoom.RecordType.transcodeRecord": i18n.t("Const.liveRoom.RecordType.transcodeRecord"),
            "Const.liveRoom.RecordType.CloudEditorOutPut": i18n.t("Const.liveRoom.RecordType.CloudEditorOutPut"),
            "Const.liveRoom.RecordType.refVideo": i18n.t("Const.liveRoom.RecordType.refVideo"),
            "Const.liveRoom.RecordType.recordVideo": i18n.t("Const.liveRoom.RecordType.recordVideo"),

            "Const.Record.PublishStatus.Init": i18n.t("Const.Record.PublishStatus.Init"),
            "Const.Record.PublishStatus.Error": i18n.t("Const.Record.PublishStatus.Error"),
            "Const.Record.PublishStatus.Success": i18n.t("Const.Record.PublishStatus.Success"),
            "Const.Record.PublishStatus.updateVideo": i18n.t("Const.Record.PublishStatus.updateVideo"),
            "Const.Record.PublishStatus.updateImage": i18n.t("Const.Record.PublishStatus.updateImage"),
            "Const.Record.PublishStatus.Push": i18n.t("Const.Record.PublishStatus.Push"),
            "Const.Record.PublishStatus.Pushing": i18n.t("Const.Record.PublishStatus.Push"),

            "Const.liveRoom.liveRecordTaskStatus.Init": i18n.t("Const.liveRoom.liveRecordTaskStatus.Init"),
            "Const.liveRoom.liveRecordTaskStatus.Starting": i18n.t("Const.liveRoom.liveRecordTaskStatus.Starting"),
            "Const.liveRoom.liveRecordTaskStatus.Recording": i18n.t("Const.liveRoom.liveRecordTaskStatus.Recording"),
            "Const.liveRoom.liveRecordTaskStatus.Stop": i18n.t("Const.liveRoom.liveRecordTaskStatus.Stop"),
 
            "Const.Goods.State.Online": i18n.t("Const.Goods.State.Online"),
            "Const.Goods.State.Offline": i18n.t("Const.Goods.State.Offline")
        };
        localizeMapper = mapper;

        for (let key in mapper) {
            let item = mapper[key];
            let reg = localizeRegexp[key] || new RegExp("\\b"+key.replace(/[.], '[.]'/)+"\\b", "gi");
            localizeRegexp[key] = reg;
            str = str.replace(reg, item);
        }

        return str;
    },
    typeof(i) {
        return /\[object (.*)\]/.exec(Object.prototype.toString.call(i))[1].toLowerCase();
    },
    formatter: (i, format) => {
        if (!i) return;

        if (!format) {
            format = helper.typeof(i);
            if (format == "number" && (
                i.toString().length == 13 ||
                i.toString().length == 10
            ))
                format = "date";

            if (format == "string") {
                if (/\d{1,2}[-\/\\]\d{1,2}[-\/\\]\d{1,2}.*\d{1,2}:\d{1,2}:\d{1,2}/.test(i))
                    format = "date"
            }
        }

        switch (format) {
            case "date":
                if (helper.typeof(i) == "number" || +i > 0) {
                    i = new Date(+(i.toString() + "0000000").substr(0, 13));
                }
                else if (helper.typeof(i) == "string") {
                    i = new Date(i.replace(/-/g, "/"));
                }

                return i.toLocaleString();
            case "duration":
                {
                    let sec = i;
                    let min = sec / 60;
                    let hour = min / 60;

                    hour = Math.floor(hour);
                    min = ("0" + Math.floor(min % 60)).substr(-2, 2);
                    sec = ("0" + Math.floor(sec % 60)).substr(-2, 2);

                    return (hour ? (hour + ":") : "") +
                        (min ? (min + ":") : "") +
                        sec;
                }
            case "durationCH":
                {
                    let sec = i;
                    let min = sec / 60;
                    let hour = min / 60;

                    hour = Math.floor(hour);
                    min = ("0" + Math.floor(min % 60)).substr(-2, 2);
                    sec = ("0" + Math.floor(sec % 60)).substr(-2, 2);

                    return (hour ? (hour + "小时") : "") +
                        (min!="00" ? (min + "分") : "") +
                        (sec!="00" ? sec+"秒":"");
                }
        }
    },
    travel(array, nodeName, callback) {
        array.forEach(n => {
            callback && callback(n);
            if(n[nodeName]) {
                helper.travel(n[nodeName], nodeName, callback);
            }
        })
    },
    loadFont(name, url) {
        let id = 'font_' + escape(name);
        let style = document.getElementById(id);
        if (!style) {
            style = document.createElement("style");
            style.id = id;
            style.type = "text/css";
            let css = '@font-face{font-family: ' + name + ';src: url("' + url + '");}';
            if(style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }
            let heads = document.getElementsByTagName("head");
            heads[0].appendChild(style);
        }
    },
    async validateFields(fields, formComponent) {
        let allRes = await Promise.all(fields.map(field =>
            new Promise((resolve, reject) => {
                try {
                    formComponent.validateField(field, errorMsg => resolve(errorMsg));
                } catch (error) {
                    reject(error);
                }
            })
        ));
        return !allRes.find(errorMsg => errorMsg != "");
    },
    async getFontName(fontFamily) {
        try {
            let ret = await api.call("watermark/sysDictoryList");
            let found = ret.data.find(font=>font.fontFamily == fontFamily);
            if(found) {
                return found.name;
            }
        } catch (e) {}
        return fontFamily;
    },
    getTree(treeData, parentIdKey, parentId) {
        const treeArr = [];
        for (let i = 0; i < treeData.length; i++) {
            let node = treeData[i];
            if (node[parentIdKey] == parentId) {
                treeArr.push({
                    ...node, children: helper.getTree(treeData, parentIdKey, node.id)
                });
            }
        }
        return treeArr;
    },
    hasCheckedNode(treeData, currentId){
        let checked;
        let checkedData;
        //若有子节点
        if (treeData.children && treeData.children.length > 0){
            //先从一级子节点找
            checkedData = treeData.children.filter(i => i.id == currentId);
            checked = !!checkedData.length;
            //若未有一级子节点被选中，遍历再下级的子节点
            if(!checked){
                for (let i = 0; i < treeData.children.length; i++){
                    if (helper.hasCheckedNode(treeData.children[i], currentId)){
                        checked = true;
                        break;
                    }
                    else checked = false;
                }
            }
        }else checked = false;
        return checked;
    },
    isPublishedRoom(liveRoomDetail) {
        return liveRoomDetail.roomType == 2 || liveRoomDetail.roomType == 4 || liveRoomDetail.roomType == 5;
    },
    isLinkLiveRoom(roomType) {
        return roomType == 4;
    },
    isSlowLiveRoom(roomType) {
        return roomType == 5;
    },
    isOutputLiveRoom(roomType) {
        return roomType == 2 || roomType == 5;
    },
    prettyFormatDateTime(dateTime) {
        // 获取当前日期和目标日期的年、月、日、时、分
        var today = new Date();
        var target = new Date(dateTime);
        var todayYear = today.getFullYear();
        var todayMonth = today.getMonth() + 1;
        var todayDay = today.getDate();
        var targetYear = target.getFullYear();
        var targetMonth = target.getMonth() + 1;
        var targetDay = target.getDate();
        var targetHour = target.getHours().toString().padStart(2, '0');
        var targetMinute = target.getMinutes().toString().padStart(2, '0');
        
        // 计算日期差
        var diff = Math.floor((target - today) / (1000 * 60 * 60 * 24));
        
        // 如果目标日期是今天、明天、后天之一，返回相应的字符串
        if (diff >= 0 && diff <= 2) {
            if (diff === 0) {
            return "今天" + targetHour + ":" + targetMinute;
            } else if (diff === 1) {
            return "明天" + targetHour + ":" + targetMinute;
            } else if (diff === 2) {
            return "后天" + targetHour + ":" + targetMinute;
            }
        }
        // 否则返回具体日期和时间的字符串
        return targetYear + "-" + targetMonth.toString().padStart(2, '0') + "-" + targetDay.toString().padStart(2, '0') + " " + targetHour + ":" + targetMinute;
    }
}

export {
    message
}
export default helper;